import { useCallback, useEffect, useState } from 'react';

/** Пауза между кодами, если бэкенд её не назвал — его же лимит, 120 секунд. */
export const DEFAULT_RESEND_AFTER = 120;

/** Лимит кодов считается за час: столько и ждём, если `retry_after` не пришёл. */
export const LIMIT_RETRY_AFTER = 60 * 60;

/**
 * Обратный отсчёт до момента, когда действие снова разрешено: следующий
 * запрос кода, следующая попытка ввода после серии неверных.
 *
 * Храним не «сколько осталось», а момент, когда можно снова: интервал тогда
 * не накапливает погрешность, а свёрнутый Telegram (таймеры там замирают)
 * после возврата сразу покажет верное значение, а не то, на котором заснул.
 */
export const useCountdown = () => {
  const [readyAt, setReadyAt] = useState(0);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (readyAt <= Date.now()) return;

    const timer = window.setInterval(() => {
      const current = Date.now();
      setNow(current);
      if (current >= readyAt) window.clearInterval(timer);
    }, 1000);

    return () => window.clearInterval(timer);
  }, [readyAt]);

  const start = useCallback((seconds: number = DEFAULT_RESEND_AFTER) => {
    const startedAt = Date.now();
    setNow(startedAt);
    setReadyAt(startedAt + Math.max(seconds, 0) * 1000);
  }, []);

  const reset = useCallback(() => setReadyAt(0), []);

  const secondsLeft = Math.max(Math.ceil((readyAt - now) / 1000), 0);

  return { secondsLeft, isOver: secondsLeft === 0, start, reset };
};

/** «1:59» — минуты без ведущего нуля, секунды с ним. */
export const formatCountdown = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;

  return `${minutes}:${String(rest).padStart(2, '0')}`;
};
